import { Project } from '../types';

const project: Project = {
  slug: 'maraica-bay',
  accessPin: '7341',
  qrTickets: ['M7T2R5'],
  info: {
    id: 4,
    title: 'Maraica Bay',
    category: {
      'en-US': 'Commercial',
      'es-MX': 'Comercial',
    },
    year: 2024,
    location: 'El manglito, La Paz, B.C.S',
    floor: '4 floors',
    building: '5,500aZA-',
    cover: '/images/Cover4.webp',
    description: {
      'en-US':
        'This coastal development blends contemporary resort architecture with lush tropical landscaping and marina integration. The design promotes a fluid connection between land and sea, using clean horizontal lines, natural textures, and rhythmic palm alignments to soften the built environment.',
      'es-MX':
        'Este desarrollo costero combina arquitectura de resort contemporanea con paisajismo tropical e integracion de marina. El diseno promueve una conexion fluida entre tierra y mar, usando lineas horizontales limpias, texturas naturales y alineaciones ritmicas de palmas para suavizar el entorno construido.',
    },
  },
  assets: {
    images: [
      { file: '4.1', ext: 'webp' },
      { file: '4.2', ext: 'webp' },
      { file: '4.3', ext: 'webp' },
      { file: '4.4', ext: 'webp' },
      { file: '4.5', ext: 'webp' },
      { file: '4.6', ext: 'webp' },
      { file: '4.7', ext: 'webp' },
      { file: '4.8', ext: 'webp' },
      { file: '4.9', ext: 'webp' },
      { file: '4.10', ext: 'webp' },
      { file: '4.11', ext: 'webp' },
      { file: '4.12', ext: 'webp' },
    ],
    videos: [],
    panos: [],
  },
};

export default project;
